<template v-slot:body>
    <b-row>
        <b-col>
            <b-overlay>
                <table class="table table-bordered">
                    <tr class="bg-light">
                        <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                        <th>{{ $t('production_store.pro_category') }}</th>
                        <th>{{ $t('production_store.pro_sub_category') }}</th>
                        <th>{{ $t('production_store.pro_name') }}</th>
                        <th>{{ $t('production_store.pro_unit') }}</th>
                        <th>{{ $t('production_store.target_quantity') }}</th>
                    </tr>
                    <tr v-for="(item, index) in dataArray.details" :key="index">
                        <td>{{ $n(index + 1) }}</td>
                        <td>{{ productCategoryById(item.category_id) }}</td>
                        <td v-if="item.sub_category_id">{{ productSubCategoryById(item.sub_category_id) }}</td>
                        <td v-else></td>
                        <td>{{ productNameById(item.product_id) }}</td>
                        <td>{{ unitNameById(item.unit_id) }}</td>
                        <td>{{ $n(item.target_quantity) }}</td>
                    </tr>
                </table>
            </b-overlay>
        </b-col>
    </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { productionTargetById } from '../../api/routes'

export default {
    props: ['id'],
    data () {
        return {
            dataArray: {
                details: []
            },
            sl: 0,
            subCategoryList: [],
            productList: [],
            productUnitList: []
        }
    },
    computed: {
        categoryList: function () {
            return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    created () {
        if (this.id) {
            this.getTargetInfoData(this.id)
        }
    },
    methods: {
        async getTargetInfoData (id) {
          const result = await RestApi.getData(productionServiceBaseUrl, productionTargetById + '/' + id)
          if (result.success) {
            this.dataArray.details = result.data.production_target_details
          }
        },
        productCategoryById (id) {
            const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        productNameById (id) {
            const product = this.productCommonObj.productList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
               return product.text_en
            }
        },
        unitNameById (id) {
            const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text_bn
            } else {
               return unit.text_en
            }
        }
    }
}
</script>
